import { render, staticRenderFns } from "./educational.vue?vue&type=template&id=231c0735&scoped=true"
import script from "./educational.vue?vue&type=script&lang=js"
export * from "./educational.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c0735",
  null
  
)

export default component.exports